export default __webpack_public_path__ + "static/media/kamba_logo.9d7973c3.png";